import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import style from "./MachineCard.module.css";
import FlexChild from 'layouts/flex/FlexChild';

function MachineCard({ item, index }) {
    
    return (
        <Draggable key={item.id} draggableId={item.id} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className={style.container}>
                        <p>{item.orderNo}</p>
                        {
                            item.image &&
                            <img src={`data:image/png;base64,${item.image}`} style={{ height: "150px" }} />
                        }
                        <p>{item.vendingName}</p>
                        <p>ID : {item.deviceCode}</p>
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default MachineCard;